import createHistory from 'history/createBrowserHistory';
import React from 'react';
import { render } from 'react-dom';

import { socketNotifier, pollNotifier } from '@artsman/ams-loader';

import { config } from './config';
import { api, connectSocket, disconnectSocket } from './reducers';
import createStore from './store';

import Routes from './routes/Routes';

let splitErrorCallback = (error, info) => {};
if (process.env.NODE_ENV === 'production') {
  // Injected by webpack...
  if (SENTRY_KEY) {
    Raven.config(SENTRY_KEY, { release: VERSION }).install();
    splitErrorCallback = (error, info) => {
      Raven.captureException(error, { extra: info });
    };
  }
}

const history = createHistory({
  basename: config.getRouterBasePath(),
  getUserConfirmation: (message, callback) => {
    if (message) {
      alert(message);
    }
    callback(false);
  }
});

// Create base Redux structure
const store = createStore(history);

// Store a version so that we can know if the underlying server has been upgraded, and invoke a refresh if it does
// change.  The version comes from the handshake data populated in director/__init__.py.
let currentVersion = void 0;
let onHandshake = function(data) {
  const { application_versions } = data;
  if (application_versions === void 0) {
    currentVersion = void 0;
  }
  else {
    const { reveal: revealVersion } = application_versions;
    if (revealVersion === void 0) {
      currentVersion = void 0;
    }
    else {
      if (currentVersion !== void 0 && currentVersion !== revealVersion) {
        console.warn('reloading the page for a reveal version change');
        location.reload();
      }
      currentVersion = revealVersion;
    }
  }
};


let notifier;
if (config.getNotifierType() === 'socket') {
  let socketOpts = {
    requiresAuthentication: true,
    path: config.getSocketPath(),
    rejectUnauthorized: false,
    onConnect: () => { store.dispatch(connectSocket()) },
    onDisconnect: () => { store.dispatch(disconnectSocket()) },
    onHandshake: onHandshake,
    transports: ['websocket', 'polling']
  };
  if (config.getApiHost()) {
    socketOpts['uri'] = config.getApiHost()
  }
  let notifier = socketNotifier(socketOpts);
  api.setNotifier(notifier);

  //notifier.onStart(); // TODO - remove this once auth integration is complete
} else if (config.getNotifierType() === 'polling') {
  let pollingOpts = {
    requiresAuthentication: true,
    interval: config.getPollingInterval()
  };
  let notifier = pollNotifier(pollingOpts);
  api.setNotifier(notifier);

  //notifier.onStart(); // TODO - remove this once auth integration is complete
}

api.checkLogin()(store.dispatch);

function renderApp(Routes) {
  // Create Root component with base routes wrapped in Redux store

  let rootComponent = (
    <Routes store={store} history={history} splitErrorCallback={splitErrorCallback}/>
  );

  if (process.env.NODE_ENV !== 'production') {
    const HotLoaderWrapper = require('react-hot-helpers').HotLoaderWrapper;

    rootComponent = (
      <HotLoaderWrapper>
        {rootComponent}
      </HotLoaderWrapper>
    );
  }

  // Render the app
  render(rootComponent, document.getElementById('root'));
}

if (window && window.navigator && window.navigator.userAgent && /Edge\/1[0-4]\./.test(window.navigator.userAgent)) {
  // Fix for bug in Microsoft Edge: https://github.com/Microsoft/ChakraCore/issues/1415#issuecomment-246424339
  console.log('Applying function.call fix for Microsoft Edge <= 14');
  Function.prototype.call = function(t) {
    return this.apply(t, Array.prototype.slice.apply(arguments, [1]));
  };
}

renderApp(Routes);

if (module.hot) {
  module.hot.accept('./routes/Routes', () => {
    renderApp(require('./routes/Routes'));
  });
}
